import { produce } from 'immer';

import { BANKRATE_LEAD_PROVIDER_ACTION_TYPE } from '../actions/bankrateLeadProvider.actions';

const initialState = {
  tokens: [],
  tokensLoading: false,
  inboundLeads: null,
  inboundLeadsLoading: false,
  aggregates: null,
  aggregatesLoading: false,
  error: null,
};

const bankrateLeadProviderReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case BANKRATE_LEAD_PROVIDER_ACTION_TYPE.GET_TOKENS_REQUEST:
        draft.tokensLoading = true;
        draft.error = null;
        break;

      case BANKRATE_LEAD_PROVIDER_ACTION_TYPE.GET_TOKENS_SUCCESS:
        draft.tokens = payload || [];
        draft.tokensLoading = false;
        draft.error = null;
        break;

      case BANKRATE_LEAD_PROVIDER_ACTION_TYPE.GET_TOKENS_FAILURE:
        draft.tokensLoading = false;
        draft.error = payload;
        break;

      case BANKRATE_LEAD_PROVIDER_ACTION_TYPE.GET_INBOUND_LEADS_REQUEST:
        draft.inboundLeadsLoading = true;
        draft.error = null;
        break;

      case BANKRATE_LEAD_PROVIDER_ACTION_TYPE.GET_INBOUND_LEADS_SUCCESS:
        draft.inboundLeads = payload || null;
        draft.inboundLeadsLoading = false;
        draft.error = null;
        break;

      case BANKRATE_LEAD_PROVIDER_ACTION_TYPE.GET_INBOUND_LEADS_FAILURE:
        draft.inboundLeadsLoading = false;
        draft.error = payload;
        break;

      case BANKRATE_LEAD_PROVIDER_ACTION_TYPE.GET_AGGREGATES_REQUEST:
        draft.aggregatesLoading = true;
        draft.error = null;
        break;

      case BANKRATE_LEAD_PROVIDER_ACTION_TYPE.GET_AGGREGATES_SUCCESS:
        draft.aggregates = payload || null;
        draft.aggregatesLoading = false;
        draft.error = null;
        break;

      case BANKRATE_LEAD_PROVIDER_ACTION_TYPE.GET_AGGREGATES_FAILURE:
        draft.aggregatesLoading = false;
        draft.error = payload;
        break;

      default:
        return state;
    }
  });

export default bankrateLeadProviderReducer;
